import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiInstance from '../../utils/axios';

function StoreFooter() {
  // Traducción eliminada, todo texto está en español.
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState('');
  const [isSubscribed] = useState(false);
  const [storeInfo, setStoreInfo] = useState({
    store_name: 'Herramientas Tayrun',
    phones: ['+595 981 123456'],
    emails: ['contacto@herramientastayrun.com.py'],
    whatsapp: '+595981123456',
    address: 'Asunción, Paraguay',
    city: 'Asunción',
    country: 'Paraguay',
    facebook: null,
    instagram: null,
    twitter: null,
    footer_text: 'Tu tienda online de confianza con los mejores productos y precios imbatibles.'
  });

  // Fetch store info from API
  useEffect(() => {
    const fetchStoreInfo = async () => {
      try {
        const response = await apiInstance.get('store-info/');
        setStoreInfo(response.data);
      } catch (error) {
        console.log('Using default store info');
      }
    };
    fetchStoreInfo();
  }, []);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email) {
      // Here you would typically send the email to your backend
      setIsSubscribed(true);
      setEmail('');
      setTimeout(() => setIsSubscribed(false), 3000);
    }
  };

  return (
    <footer className="modern-footer" style={{ marginTop: 'auto' }}>
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="container">
          <div className="row g-4">
            {/* Company Info */}
            <div className="col-lg-5 col-md-6">
              <div className="footer-section">
                <div className="footer-logo mb-3">
                  <h3 className="text-white fw-bold mb-2">
                    <i className="fas fa-tools text-warning me-2"></i>
                    {storeInfo.store_name || 'Herramientas Tayrun'}
                  </h3>
                <p className="text-light mb-3">
                  {storeInfo.footer_text || 'Tu tienda online de confianza con los mejores productos y precios imbatibles.'}
                </p>
                </div>
                
                {/* Contact Info */}
                <div className="contact-info">
                  <div className="d-flex align-items-center mb-2">
                    <i className="fas fa-phone text-warning me-2"></i>
                    <span className="text-light">{storeInfo.phones?.[0] || '+595 981 123456'}</span>
                  </div>
                  <div className="d-flex align-items-center mb-2">
                    <i className="fas fa-envelope text-warning me-2"></i>
                    <span className="text-light">{storeInfo.emails?.[0] || 'contacto@herramientastayrun.com.py'}</span>
                  </div>
                  <div className="d-flex align-items-center mb-3">
                    <i className="fas fa-map-marker-alt text-warning me-2"></i>
                    <span className="text-light">{storeInfo.address || `${storeInfo.city || 'Asunción'}, ${storeInfo.country || 'Paraguay'}`}</span>
                  </div>
                </div>

                {/* Social Media */}
                <div className="social-links">
                  <h6 className="text-white mb-2">Seguinos</h6>
                  <div className="d-flex gap-2">
                    {storeInfo.instagram && (
                      <a href={storeInfo.instagram} target="_blank" rel="noopener noreferrer" className="social-link" title="Instagram">
                        <i className="fab fa-instagram"></i>
                      </a>
                    )}
                    {storeInfo.facebook && (
                      <a href={storeInfo.facebook} target="_blank" rel="noopener noreferrer" className="social-link" title="Facebook">
                        <i className="fab fa-facebook-f"></i>
                      </a>
                    )}
                    {storeInfo.twitter && (
                      <a href={storeInfo.twitter} target="_blank" rel="noopener noreferrer" className="social-link" title="Twitter">
                        <i className="fab fa-twitter"></i>
                      </a>
                    )}
                    <a href={`https://wa.me/${(storeInfo.whatsapp || '+595981123456').replace(/[^0-9]/g, '')}`} target="_blank" rel="noopener noreferrer" className="social-link" title="WhatsApp">
                       <i className="fab fa-whatsapp"></i>
                     </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Quick Links & Account */}
            <div className="col-lg-3 col-md-6">
              <div className="footer-section">
                <h5 className="text-white mb-3">Navegación</h5>
                <ul className="footer-links">
                  <li><Link to="/">Inicio</Link></li>
                  <li><Link to="/products/">Productos</Link></li>
                  <li><Link to="/about/">Sobre Nosotros</Link></li>
                  <li><Link to="/contact/">Contacto</Link></li>
                  <li><Link to="/faq/">Preguntas Frecuentes</Link></li>
                  <li><Link to="/login/">Mi Cuenta</Link></li>
                  <li><Link to="/customer/orders/">Mis Pedidos</Link></li>
                </ul>
              </div>
            </div>

            {/* Newsletter & Legal */}
            <div className="col-lg-4 col-md-12">
              <div className="footer-section">
                <h5 className="text-white mb-3">Newsletter</h5>
                <p className="text-light small mb-3">
                  Recibí ofertas exclusivas y novedades primero.
                </p>
                <form onSubmit={handleNewsletterSubmit} className="newsletter-form">
                  <div className="input-group mb-2">
                    <input 
                      type="email" 
                      placeholder="Tu correo electrónico"
                      className="form-control"
                      aria-label="Correo electrónico para newsletter"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <button className="btn btn-warning" type="submit">
                      <i className="fas fa-paper-plane"></i>
                    </button>
                  </div>
                  {isSubscribed ? (
                    <small className="text-success fw-bold">
                      <i className="fas fa-check-circle me-1"></i>
                      ¡Inscripción exitosa!
                    </small>
                  ) : (
                    <small className="text-light opacity-75">
                      ¡Prometemos no enviar spam!
                    </small>
                  )}
                </form>
                <div className="mt-3">
                  <Link to="/privacy/" className="text-light small me-3">Privacidad</Link>
                  <Link to="/terms/" className="text-light small">Términos</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="text-light mb-0 small">
                © {currentYear} {storeInfo.store_name || 'Herramientas Tayrun'}. Todos los derechos reservados.
              </p>
            </div>
            <div className="col-md-6 text-md-end">
              <div className="payment-methods">
                <span className="text-light small me-2">Formas de Pago:</span>
                <div className="payment-icons">
                  <i className="fab fa-cc-visa text-light me-2" title="Visa"></i>
                  <i className="fab fa-cc-mastercard text-light me-2" title="Mastercard"></i>
                  <i className="fab fa-cc-amex text-light me-2" title="American Express"></i>
                  <i className="fas fa-qrcode text-light me-2" title="Pago QR"></i>
                  <i className="fas fa-barcode text-light me-2" title="Pago en caja"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <style>{`
        .modern-footer {
          background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
          color: white;
          margin-top: auto;
        }

        .footer-main {
          padding: 60px 0 40px;
        }

        .footer-section h5 {
          font-weight: 600;
          margin-bottom: 20px;
          position: relative;
        }

        .footer-section h5::after {
          content: '';
          position: absolute;
          bottom: -8px;
          left: 0;
          width: 30px;
          height: 2px;
          background: #ffc107;
        }

        .footer-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .footer-links li {
          margin-bottom: 12px;
        }

        .footer-links a {
          color: #e9ecef;
          text-decoration: none;
          transition: all 0.3s ease;
          display: inline-block;
        }

        .footer-links a:hover {
          color: #ffc107;
          transform: translateX(5px);
        }

        .social-links .social-link {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 40px;
          height: 40px;
          background: rgba(255, 255, 255, 0.1);
          color: white;
          border-radius: 50%;
          text-decoration: none;
          transition: all 0.3s ease;
          margin-right: 10px;
        }

        .social-links .social-link:hover {
          background: #ffc107;
          color: #1e3c72;
          transform: translateY(-3px);
        }

        .contact-info i {
          width: 20px;
        }

        .newsletter-form input {
          background: rgba(255, 255, 255, 0.1);
          border: 1px solid rgba(255, 255, 255, 0.2);
          color: white;
        }

        .newsletter-form input::placeholder {
          color: rgba(255, 255, 255, 0.7);
        }

        .newsletter-form .btn {
          background: #ffc107;
          border: none;
          color: #1e3c72;
          font-weight: 600;
        }

        .newsletter-form .btn:hover {
          background: #e0a800;
          transform: translateY(-2px);
        }

        .newsletter-form .input-group {
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        }

        .newsletter-form .form-control:focus {
          border-color: #ffc107;
          box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.25);
        }

        .newsletter-form .text-success {
          animation: fadeIn 0.5s ease-in;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .footer-section {
          position: relative;
        }

        .footer-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.02), transparent);
          pointer-events: none;
        }


        .footer-bottom {
          background: rgba(0, 0, 0, 0.2);
          padding: 20px 0;
          border-top: 1px solid rgba(255, 255, 255, 0.1);
        }

        .payment-methods i {
          font-size: 20px;
        }

        .payment-icons i {
          font-size: 22px;
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .payment-icons i:hover {
          transform: scale(1.2);
          color: #ffc107 !important;
        }

        @media (max-width: 768px) {
          .footer-main {
            padding: 40px 0 20px;
          }
          
          .footer-section {
            text-align: center;
            margin-bottom: 30px;
          }
          
          .footer-section h5::after {
            left: 50%;
            transform: translateX(-50%);
          }

          .scroll-to-top {
            bottom: 20px;
            right: 20px;
            width: 45px;
            height: 45px;
            font-size: 16px;
          }
        }
      `}</style>
    </footer>
  );
}

export default StoreFooter;